import React from 'react';

import * as Page from 'Pages';

const RoutesSchema = {
  authorized: [
    {
      name: 'Home',
      path: '/home',
      render: (props) => <Page.Home {...props} />,
      exact: true
    },
    {
      name: 'Pipeline',
      path: '/pipelines',
      render: (props) => <Page.Ingestion {...props} />,
      exact: true,
      nested: [
        {
          name: 'New Pipeline',
          path: '/pipelines/new',
          render: (props) => <Page.NewPipeline {...props} />,
          exact: true
        },
        {
          name: 'Pipeline Details',
          path: '/pipelines/:pipelineId/edit',
          render: (props) => <Page.PipelineDetails {...props} />,
          exact: true
        }
      ]
    },
    {
      name: 'SDI-Pipeline',
      path: '/sdi_pipelines',
      render: (props) => <Page.SDIPipeline {...props} />,
      exact: true,
      nested: [
        {
          name: 'New Pipeline',
          path: '/sdi_pipelines/new',
          render: (props) => <Page.SDINewPipeline {...props} />,
          exact: true
        },
        {
          name: 'Pipeline Details',
          path: '/sdi_pipelines/:pipelineId/edit',
          render: (props) => <Page.SDIPipelineDetails {...props} />,
          exact: true
        }
      ]
    },
    {
      name: 'Jobs',
      path: '/jobs',
      render: (props) => <Page.Jobs {...props} />,
      exact: true,
      nested: [
        {
          name: 'Job',
          path: '/jobs/:jobId',
          render: (props) => <Page.JobContainer {...props} />,
          exact: true
        }
      ]
    },
    {
      name: 'Visualize',
      path: '/visualization',
      render: (props) => <Page.Visualization {...props} />,
      exact: true,
      nested: [
        {
          name: 'Advanced Visualization',
          path: '/visualization/advanced',
          render: (props) => <Page.Visualization {...props} />,
          exact: true
        }
      ]
    },
    {
      name: 'Sandbox',
      path: '/sandbox',
      render: (props) => <Page.Sandbox {...props} />,
      exact: true
    },
    {
      name: 'Catalog',
      path: '/catalog',
      render: (props) => <Page.Catalog {...props} />,
      exact: true
    },
    {
      name: 'Add-ons',
      path: '/addons',
      render: (props) => <Page.Addons {...props} />,
      exact: true
    },
    {
      name: 'Exports',
      path: '/export',
      render: (props) => <Page.Exports {...props} />,
      exact: true
    },
    {
      name: 'Marketplace',
      path: '/marketplace',
      render: (props) => <Page.Marketplace {...props} />,
      exact: true,
      nested: [
        {
          name: 'Datasets',
          path: '/marketplace/:marketplaceId',
          render: (props) => <Page.MarketplaceDetails {...props} />,
          exact: true
        }
      ]
    },
    {
      name: 'Chat2Dash',
      path: '/chat2dash',
      render: (props) => <Page.Chat2Dash {...props} />,
      exact: true
    },
    {
      name: 'Manager',
      path: '/manager',
      render: () => null,
      exact: true,
      nested: [
        {
          name: 'Users Management',
          path: '/manager/users',
          render: (props) => <Page.ManageUsers {...props} />,
          exact: true
        }
      ]
    },
    {
      name: 'Support',
      path: '/support',
      render: (props) => <Page.Support {...props} />,
      exact: true
    }
  ],
  unauthorized: [
    {
      name: 'login',
      path: '/login',
      render: (props) => <Page.Login {...props} />,
      exact: true
    },
    {
      name: 'callback',
      path: '/callback',
      render: (props) => <Page.Callback {...props} />,
      exact: true
    },
    {
      name: 'register',
      path: '/register',
      render: (props) => <Page.Register {...props} />,
      exact: true
    }
    // {
    //   name: 'inviteUsers',
    //   path: '/signup',
    //   render: (props) => <Page.Invite {...props} />,
    //   exact: true
    // }
  ]
};

export default RoutesSchema;
